import { Link, useParams } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

const CONTENT = {
  terms: {
    title: "Terms & Conditions",
    sections: [
      ["Booking & Confirmation", "A booking is confirmed only after receipt of the advance payment and written confirmation from click2trip via email or WhatsApp. Quotes are valid for 72 hours unless stated otherwise."],
      ["Pricing", "All prices are per person on twin/double sharing unless mentioned. Prices may change due to currency fluctuation, fuel surcharges or supplier revisions before full payment."],
      ["Travel Documents", "Travellers are responsible for valid passports (6+ months validity), visas and health documents. We assist with visa documentation but issuance is at the sole discretion of the embassy."],
      ["Changes by Traveller", "Date or itinerary changes are subject to availability and applicable supplier charges. Free date changes are offered up to 15 days before departure on most packages."],
      ["Liability", "click2trip acts as an agent for airlines, hotels and transport providers. We are not liable for delays, cancellations or service deficiencies by third-party suppliers, though we will always advocate on your behalf."],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    sections: [
      ["What We Collect", "Name, contact details, travel preferences and payment confirmations — only what's needed to plan and book your trip."],
      ["How We Use It", "To prepare quotes, make bookings, process visas and provide trip support. We never sell your data to third parties."],
      ["Sharing", "Details are shared only with suppliers (airlines, hotels, embassies) strictly as required to fulfil your booking."],
      ["Storage & Security", "Data is stored on secured servers with access limited to your trip team. You may request deletion of your data anytime by emailing sales@click2trip.in."],
      ["Cookies", "Our site uses minimal cookies for analytics and session management. You can disable them in your browser without affecting core functionality."],
    ],
  },
  refund: {
    title: "Cancellation & Refund Policy",
    sections: [
      ["30+ days before departure", "Full refund minus a processing fee of ₹2,500 per person."],
      ["15–29 days before departure", "75% of the package cost is refunded; 25% is retained towards committed supplier advances."],
      ["7–14 days before departure", "50% of the package cost is refunded."],
      ["Under 7 days / no-show", "No refund, as hotels and transport are fully committed. We will, however, help you reschedule where suppliers permit."],
      ["Refund Timeline", "Approved refunds are processed to the original payment method within 7–10 working days. Visa fees, once applied, are non-refundable regardless of outcome."],
      ["Force Majeure", "For cancellations due to natural disasters, pandemics or government restrictions, we offer a full credit note valid 12 months or refunds per supplier policy."],
    ],
  },
};

export default function Policies() {
  const { type } = useParams();
  const page = CONTENT[type] || CONTENT.terms;

  return (
    <div className="pt-32 pb-24" data-testid="policies-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <Reveal>
          <div className="flex gap-3 mb-10">
            {Object.entries(CONTENT).map(([key, c]) => (
              <Link key={key} to={`/policies/${key}`} data-testid={`policy-tab-${key}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${type === key ? "bg-ink text-bone" : "bg-sand/60 text-ink/60 hover:bg-sand"}`}>
                {c.title.split(" ")[0]}
              </Link>
            ))}
          </div>
          <h1 className="font-display text-4xl sm:text-5xl font-black mb-12" data-testid="policy-title">{page.title}</h1>
        </Reveal>
        <div className="space-y-10">
          {page.sections.map(([h, body], i) => (
            <Reveal key={h} delay={i * 0.05}>
              <div data-testid={`policy-section-${i}`}>
                <h2 className="font-display text-xl font-bold mb-3 flex items-baseline gap-3">
                  <span className="text-sun text-sm font-black">{String(i + 1).padStart(2, "0")}</span> {h}
                </h2>
                <p className="text-ink/70 leading-relaxed">{body}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="mt-14 text-sm text-ink/50">Last updated: June 2026 · Questions? Email sales@click2trip.in</p>
      </div>
    </div>
  );
}
